module.exports = "\n<div class=\"page-container\">\n\t\n\t<router-outlet></router-outlet>\n\n</div>"